var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.onClick}},[(!_vm.loading)?_c('span',[_vm._v("Sign up")]):_vm._e(),(_vm.loading)?_c('Loader',{attrs:{"auto":true,"color":"white"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }